
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FinancialChart } from "./FinancialChart";
import { FinancialData } from "../types";

interface ChartGridProps {
  isLoadingFinancials: boolean;
  financialData: FinancialData | null;
}

export const ChartGrid = ({ isLoadingFinancials, financialData }: ChartGridProps) => {
  if (isLoadingFinancials) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        {[...Array(6)].map((_, i) => (
          <Card key={i} className="h-64">
            <CardContent className="flex items-center justify-center h-full">
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
                <p className="text-sm text-gray-600">Loading chart...</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (!financialData || !financialData.labels.length) {
    return (
      <div className="mt-4 p-4 text-center text-gray-600">
        <p>No financial data available. Please fetch data first.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.revenue} 
            title="Revenue" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>

      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.profit} 
            title="Gross Profit" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>

      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.ebitdaMargins} 
            title="EBITDA Margins" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>

      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.eps} 
            title="EPS" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>

      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.cashFlow} 
            title="Free Cash Flow" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>

      <Card className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10">
        <CardContent className="p-4">
          <FinancialChart 
            data={financialData.debt} 
            title="Total Debt" 
            financialData={financialData} 
          />
        </CardContent>
      </Card>
    </div>
  );
};
